import { useSelector, useDispatch } from "react-redux";
import usePatch from "src/hooks/rest/usePatch";
import { updateProfile } from "src/redux/auth";

export default function useEditProfile() {
	const user = useSelector((state: any) => state.auth);
	const dispatch = useDispatch();
	const [patchProfile, loading] = usePatch(
		user.type === "student" ? "/auth/profile" : "/auth/profile/company"
	);

	const editProfile = async (data: any) => {
		const res = await patchProfile(data);
		dispatch(updateProfile(res.data));
	};

	return [editProfile, loading] as [(data: any) => Promise<any>, boolean];
}
